import classNames from 'classnames';
import React, { useContext } from 'react';
import { useIsMobile } from '~/context/common/DeviceContext';
import SpinnerContext from '~/context/vdp/SpinnerContext';
import { usePageHeaderHeight } from './hooks';

function useShowSpinnerOnTop(): boolean {
  const isMobile = useIsMobile();
  const { isInTourMode, isSpinnerImmersive } = useContext(SpinnerContext);

  return isSpinnerImmersive || (isMobile && isInTourMode);
}

export default function SectionsWrapper({ children }: React.PropsWithChildren) {
  const ref = usePageHeaderHeight<HTMLDivElement>();
  const showSpinnerOnTop = useShowSpinnerOnTop();

  return (
    <>
      <div id="vdp-events" />
      <div
        className={classNames('m:relative', {
          'm:z-1': !showSpinnerOnTop
        })}
        ref={ref}
      >
        {children}
      </div>
    </>
  );
}
